import { formatTokens, formatDuration } from '../lib/format';

interface Props {
  inputTokens?: number;
  outputTokens?: number;
  totalTokens?: number;
  timeToFirstToken?: number;
  duration?: number;
  models?: Array<{ id: string; provider: string }>;
}

export function RunMetrics(props: Props) {
  if (!props.totalTokens && !props.duration) return null;
  return (
    <div class="flex items-center gap-3 text-[11px] text-muted-foreground font-mono tabular-nums mt-1.5">
      {(props.inputTokens || props.outputTokens) && (
        <span class="inline-flex items-center gap-1">
          <i class="ph ph-hash text-xs" /> {formatTokens(props.inputTokens)}→{formatTokens(props.outputTokens)}
        </span>
      )}
      {props.timeToFirstToken != null && (
        <span class="inline-flex items-center gap-1">
          <i class="ph ph-lightning text-xs" /> ttft {formatDuration(props.timeToFirstToken)}
        </span>
      )}
      {props.duration != null && (
        <span class="inline-flex items-center gap-1">
          <i class="ph ph-clock text-xs" /> {formatDuration(props.duration)}
        </span>
      )}
      {props.models?.map((m) => (
        <span class="inline-flex items-center gap-1">
          · {m.id}
        </span>
      ))}
    </div>
  );
}
